import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
// import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/',
    name: 'PageHome',
    component: () => import(/* webpackChunkName: "about" */ '../views/PageHome.vue'),
    meta: { keepAlive: false }

  },
  {
    path: '/HelloWorld',
    name: 'HelloWorld',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../components/HelloWorld.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/MyDetails',
    name: 'MyDetails',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/MyDetails.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/UsersLogin',
    name: 'UsersLogin',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UsersLogin.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/PersonalCenter.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/TenantPersonalCenter',
    name: 'TenantPersonalCenter',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/TenantPersonalCenter.vue'),
    meta: { keepAlive: false }
  },
  {
    //物业系统
    path: '/AddPhysicalDistribution',
    name: 'AddPhysicalDistribution',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/AddPhysicalDistribution.vue'),
    meta: { keepAlive: false }

  },
  {
    path: '/MyStatusLog',
    name: 'MyStatusLog',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/MyStatusLog.vue'),
    meta: { keepAlive: false }

  },
  {
    path: '/MyPhysicalDistribution',
    name: 'MyPhysicalDistribution',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/MyPhysicalDistribution.vue'),
    meta: { keepAlive: false }

  },
  {
    //客户管理
    path: '/CustomerManagement',
    name: 'CustomerManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/CustomerManagement.vue'),
    meta: { keepAlive: false }
    

  },
  {
    //客户管理
    path: '/ChattingRecords',
    name: 'ChattingRecords',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/ChattingRecords.vue'),
    meta: { keepAlive: false }

  },
  {
    //订单管理-合同订单
    path: '/TownshipEnterprises',
    name: 'TownshipEnterprises',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/TownshipEnterprises.vue'),
    meta: { keepAlive: false }

  },
  {
    //订单管理-新增签约
    path: '/NewSigning',
    name: 'NewSigning',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/NewSigning.vue'),
    meta: { keepAlive: false }

  },
  {
    //订单管理-到期提醒
    path: '/ExpirationReminder',
    name: 'ExpirationReminder',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/ExpirationReminder.vue'),
    meta: { keepAlive: false }

  },
  {
    //订单管理-到期提醒
    path: '/ContractManagement',
    name: 'ContractManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/ContractManagement.vue'),
    meta: { keepAlive: false }
 
  },
  {
    //订单管理-到期提醒
    path: '/NewHousing',
    name: 'NewHousing',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/NewHousing.vue'),
    meta: { keepAlive: false }

  },
  {
    //订单管理-到期提醒
    path: '/RentContro',
    name: 'RentContro',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/RentContro.vue'),
    meta: { keepAlive: false }

  },
  {
    //通告
    path: '/NoticeContent',
    name: 'NoticeContent',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/NoticeContent.vue'),
    meta: { keepAlive: false }

  },
  {
    //需求处理

    path: '/DemandProcessing',
    name: 'DemandProcessing',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/DemandProcessing.vue'),
    meta: { keepAlive: false }

  },
  {
    //需求处理

    path: '/CrossSwitch',
    name: 'CrossSwitch',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/CrossSwitch.vue'),
    meta: { keepAlive: false }

  },
  {
    //通告详情

    path: '/NoticeParticulars',
    name: 'NoticeParticulars',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/NoticeParticulars.vue'),
    meta: { keepAlive: false }

  },
  {
    //通告详情

    path: '/RentalPostings',
    name: 'RentalPostings',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/RentalPostings.vue'),
    meta: { keepAlive: false }

  },

  {
    //个人-租赁信息 -上传附件

    path: '/UploadAttachment',
    name: 'UploadAttachment',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UploadAttachment.vue'),
    meta: { keepAlive: false }

  },
  {
    //个人-租赁信息 -上传附件

    path: '/DataManagement',
    name: 'DataManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/DataManagement.vue'),
    meta: { keepAlive: false }

  },

  {
    //需求

    path: '/LesseeDemandProcessing',
    name: 'LesseeDemandProcessing',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/LesseeDemandProcessing.vue'),
    meta: { keepAlive: false }

  },
  {
    //个人-需求处理

    path: '/UserDemandProcessing',
    name: 'UserDemandProcessing',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UserDemandProcessing.vue'),
    meta: { keepAlive: false }

  },
  {
    //个人-需求处理

    path: '/ManagerDemandProcessing',
    name: 'ManagerDemandProcessing',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagerDemandProcessing.vue'),
    meta: { keepAlive: false }
  },
  {
    //管理员-房東管理

    path: '/LandlordManagement',
    name: 'LandlordManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/LandlordManagement.vue'),
    meta: { keepAlive: false }

  },
  {
    //管理员-房屋查看

    path: '/HouseInspection',
    name: 'HouseInspection',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/HouseInspection.vue'),
    meta: { keepAlive: false }

  },
  {
    //管理员-信息发布

    path: '/InformationPublish',
    name: 'InformationPublish',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/InformationPublish.vue'),
    meta: { keepAlive: false }

  },
  {
    //管理员-房東管理

    path: '/UserManagement',
    name: 'UserManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UserManagement.vue'),
    meta: { keepAlive: false }

  },
  {
    //管理员-房東管理

    path: '/PropertyManagement',
    name: 'PropertyManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/PropertyManagement.vue'),
    meta: { keepAlive: false }

  },
   {
    //管理员-区域管理

    path: '/AdminDataManagement',
    name: 'AdminDataManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/AdminDataManagement.vue'),
    meta: { keepAlive: false }

  },
    {
    //管理员-租金管理

    path: '/rentManagement',
    name: 'rentManagement',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/rentManagement.vue'),
    meta: { keepAlive: false }

  },
  {
    //修改房源

    path: '/HousingResource',
    name: 'HousingResource',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/HousingResource.vue'),
    meta: { keepAlive: false }

  },
  {
    //+新增標簽

    path: '/AddNewTag',
    name: 'AddNewTag',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/AddNewTag.vue'),
    meta: { keepAlive: false }

  },
  {
    //+添加客戶
    path: '/AddCustomer',
    name: 'AddCustomer',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/AddCustomerManagement.vue'),
    meta: { keepAlive: false }

  },
  {
    //+新增標簽

    path: '/UserExpirationReminder',
    name: 'UserExpirationReminder',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UserExpirationReminder.vue'),
    meta: { keepAlive: false }

  },

  {
    //+新增標簽

    path: '/UserNoticeParticulars',
    name: 'UserNoticeParticulars',
    // 路由级代码拆分
    component: () => import(/* webpackChunkName: "about" */ '../views/UserNoticeParticulars.vue'),
    meta: { keepAlive: false }

  },
]

// 动态路由，基于用户权限动态去加载
  // {
  //   path: "",
  //   component: "Layout",
  //   redirect: "overview",
  //   name: "overview",
  //   path: "/",
  //   meta: { title: "首页", icon: "home", affix: false },
  //   children: [
  //     {
  //       path: "overview",
  //       component: "home/index",
  //       name: "overviewIndex",
  //       meta: { title: "经营总览", icon: "", affix: false },
  //     },
  //     {
  //       path: "dealStatistics",
  //       component: "home/dealStatistics",
  //       name: "dealStatistics",
  //       meta: { title: "交易统计", icon: "", affix: false },
  //     },
  //   ],
  // },
  // 店铺
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
